<template>
  <v-app>
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <v-flex class="text-sm-center" style="max-width:400px">
          <img src="../../assets/logo.png" width="400" alt="" />
          <h2 class="headline" style="color:#4a89dc;font-weight:300">Forgotten Password</h2>
          <v-card style="text-align:left">
            <v-card-text>
              <v-form ref="form" lazy-validation>
                <v-text-field
                  name="email"
                  label="Email"
                  v-model="email"
                  :rules="emailRules"
                  required
                  autocomplete="username"
                ></v-text-field>
                <v-btn flat colour="primary" href="/login"><v-icon>arrow_back</v-icon> return to login</v-btn>
                <v-btn @click="forgottenPassword({ email })" large block color="blue" dark>Continue</v-btn>
              </v-form>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <abf-app-notifications />
  </v-app>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { emailRules } from '@/utils/validators';
import AbfAppNotifications from '@/components/Abf/AbfAppNotifications';

export default {
  name: 'forgotten-password',
  components: { AbfAppNotifications },
  data: () => ({
    email: null,
    hidePassword: true,
    emailRules
  }),
  computed: {
    ...mapState({
      user: state => state.user
    })
  },
  methods: {
    ...mapActions(['forgottenPassword'])
  }
};
</script>

<style lang="scss" scoped>
h2 {
  margin-top: 1rem;
  margin-bottom: 1rem;
}

a.btn {
  margin: 18px 0;
}

a ::v-deep.btn__content {
  padding: 1rem 0;
}
</style>
